<template>
    <div class="c-modal-wrapper c-gray-back">
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-12">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Zatvori</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header> 
      <!-- Body content -->
      <div class="c-modal-body">
        <div class="c-responsive-container">
          <div class="c-p-10 c-align-center">
            Detalji vašeg korisničkog naloga:
            <br/>
            <br/>
            <div class="c-fs-14" v-if="receivedFirebaseUser && receivedFirebaseUser.currentUser && receivedFirebaseUser.userDetails">
              <!-- <div v-if="receivedFirebaseUser.currentUser.uid">uid: {{receivedFirebaseUser.currentUser.uid}}</div> -->
              <div v-if="receivedFirebaseUser.currentUser.email">Email: {{receivedFirebaseUser.currentUser.email}}</div>
              <!-- <div v-if="receivedFirebaseUser.userDetails.enterPass">enterPass: {{receivedFirebaseUser.userDetails.enterPass}}</div> -->
              <div v-if="receivedFirebaseUser.userDetails.firstName">Ime: {{receivedFirebaseUser.userDetails.firstName}}</div>
              <div v-if="receivedFirebaseUser.userDetails.lastName">Prezime: {{receivedFirebaseUser.userDetails.lastName}}</div>
              <div v-if="receivedFirebaseUser.userDetails.nickName">Nadimak: {{receivedFirebaseUser.userDetails.nickName}}</div>
            </div>                       
          </div>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
export default {
  name: 'ModalWhoAmI',
  props: ['inputModalData'],
  data () {
    return {
      msg: 'ModalWhoAmI modal',
      receivedFirebaseUser: null,
      resolve: null,
      reject: null
    }
  },
  methods: {
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalWhoAmI component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      if (this.inputModalData.dataForModal){
        this.receivedFirebaseUser = this.inputModalData.dataForModal;
      }      
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
    }
  },
  mounted () {
    //console.log('~ mounted - ModalWhoAmI component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalWhoAmI component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/adminsList/ModalWhoAmI.vue